import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
// import { enqueueSnackbar } from 'notistack';
import WebsiteAppointmentRequests from './components/WebsiteAppointmentRequests';
import * as api from '../../services/api/admin';
import TabPanel from '../../components/TabPanel';

const PREMIUM_TAB = 0;
const FREEMIUM_TAB = 1;

class ProviderAdminSuperAdminAppointmentRequests extends Component {
  state = {
    isLoading: false,
    tabPosition: 0,
    appointmentRequests: [],
    pageIndex: 0,
    pageLimit: 20
  };

  async componentDidMount() {
    try {
      const appointmentRequests = await this.fetchAppointmentRequestsFromWebsite(
        this.state.tabPosition
      );
      this.setState({ appointmentRequests });
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  fetchAppointmentRequestsFromWebsite = async tabPosition => {
    const { enqueueSnackbar } = this.props;
    const { pageIndex } = this.state;
    try {
      this.setState({ isLoading: true });
      if (tabPosition === PREMIUM_TAB) {
        return api.fetchAppointmentRequestsFromWebsite({ premium: true, offset: pageIndex * 20 });
      } else if (tabPosition === FREEMIUM_TAB) {
        return api.fetchAppointmentRequestsFromWebsite({ freemium: true, offset: pageIndex * 20 });
      } else {
        return api.fetchAppointmentRequestsFromWebsite({ archived: true, offset: pageIndex * 20 });
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar(
        'Unable to fetch appointment requests, please try again.'
      );
    }
  };

  onSaveAppointmentRequest = async appointmentRequest => {
    const { enqueueSnackbar } = this.props;
    try {
      await api.updateAppointmentRequest({
        id: appointmentRequest.id,
        portalNotes: appointmentRequest.portalNotes,
      });
      enqueueSnackbar('Appointment request updated!');
    } catch (err) {
      enqueueSnackbar('Oops, something went wrong. Please Try again');
    } finally {
      const appointmentRequests = await this.fetchAppointmentRequestsFromWebsite(
        this.state.tabPosition
      );
      this.setState({ appointmentRequests });
    }
  };

  handleTabPositionChange = async (event, newTabPosition) => {
    this.setState({ tabPosition: newTabPosition });
    const appointmentRequests = await this.fetchAppointmentRequestsFromWebsite(
      newTabPosition
    );
    this.setState({ appointmentRequests });
  };

  onArchiveAppointmentRequest = async request => {
    const { enqueueSnackbar } = this.props;
    const { tabPosition } = this.state;
    try {
      await api.archiveAppointmentRequest(request.id);
    } catch (err) {
      enqueueSnackbar(
        'Failed to archive appointment request. Please try again.'
      );
    } finally {
      const appointmentRequests = await this.fetchAppointmentRequestsFromWebsite(
        tabPosition
      );
      this.setState({ appointmentRequests });
    }
  };

  onPageForward = async () => {
    //this won't cover the case where the total num of consult notes % PAGE_LIMIT = 0. But it's a quick fix for now.
    const { tabPosition } = this.state;
    const { enqueueSnackbar } = this.props;
    if (this.state.appointmentRequests.length < this.state.pageLimit) {
      enqueueSnackbar('You are on the last page');
    }
    else {
      this.setState({ pageIndex: this.state.pageIndex + 1 }, async () => {
        const appointmentRequests = await this.fetchAppointmentRequestsFromWebsite(
          tabPosition
        );
        this.setState({ appointmentRequests });
      });
    }
  };

  onPageBack = async () => {
    const { tabPosition } = this.state;
    const { enqueueSnackbar } = this.props;
    if (this.state.pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    }
    else {
      this.setState({ pageIndex: this.state.pageIndex - 1 }, async () => {
        const appointmentRequests = await this.fetchAppointmentRequestsFromWebsite(
          tabPosition
        );
        this.setState({ appointmentRequests });
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { tabPosition, appointmentRequests, pageIndex, pageLimit } = this.state;

    return (
      <Grid container classes={{ container: classes.container }}>
        <Grid item xs={12} lg={6} classes={{ item: classes.header }}>
          <Typography variant="h2" className={classes.headerText}>
            Appointment Requests Beta
          </Typography>

          <Typography variant="body1" className={classes.helpText}>
            Manage appointment requests <strong>from the website</strong>, those
            that are <strong>requested by patients</strong>. In order to meet
            the expectations we're setting we've built a central place to see all
            of those requests.
          </Typography>

          <Typography variant="body1" className={classes.helpText}>
            You'll be able to view the appointment request details, follow up
            with the patient or provider, and admin leave notes. <strong>Admin notes
            are only seen by Qwell admins</strong>.
          </Typography>
        </Grid>

        <AppBar
          position="static"
          color="default"
          classes={{ root: classes.appBar }}
        >
          <Tabs
            value={tabPosition}
            onChange={this.handleTabPositionChange}
          >
            <Tab label="Premium" />
            <Tab label="Freemium" />
            <Tab label="Archived" />
          </Tabs>
        </AppBar>

        <TabPanel>
          <WebsiteAppointmentRequests
            appointmentRequests={appointmentRequests}
            onArchiveAppointmentRequest={this.onArchiveAppointmentRequest}
            tabPosition={tabPosition}
            onSaveAppointmentRequest={this.onSaveAppointmentRequest}
            onPageForward={this.onPageForward}
            onPageBack={this.onPageBack}
            pageIndex={pageIndex}
            pageLimit={pageLimit}
          />
        </TabPanel>
      </Grid>
    );
  }
}

const styles = () => ({
  container: {
    padding: '3em',
  },
  appBar: {
    zIndex: 10,
  },
  header: {
    paddingBottom: '3em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '19px',
    color: '#1C1C1C',
    paddingBottom: '0.5em',
  },
  helpText: {
    paddingBottom: '0.5em',
  },
});

export default withSnackbar(
  withStyles(styles)(ProviderAdminSuperAdminAppointmentRequests)
);
